export const GET_ALL = "GET_ALL"
export const GET = "GET"
export const ADD = "ADD"
export const UPDATE = "UPDATE"
export const DELETE = "DELETE"
export const LOADING = "LOADING"
export const LOADING_FALSE = "LOADING_FALSE"